import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
}
//# sourceMappingURL=dummy_controller.js.map